import { createReducer } from '@reduxjs/toolkit'

import { campaignNegativeKeywordsTableColumnsConfig } from 'configuration/tables/negativeKeywordsTable'
import { NEGATIVE_KEYWORD_TEXT } from 'const/filters'
import { LOCAL_FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [NEGATIVE_KEYWORD_TEXT]: null,
    },
    [FILTER_SETTINGS]: {
        anchored: [NEGATIVE_KEYWORD_TEXT],
    },
    table: getDefaultTable(
        serializeColumns(campaignNegativeKeywordsTableColumnsConfig),
        {
            sorter: {
                field: 'amazon_creation_date',
                order: 'descend',
            },
        }
    ),
}

export default createReducer(initialState, () => {})
